// extracted by mini-css-extract-plugin
export default {"wrap":"yr-z","melodyCategory":"zr-z","fullWidth":"Ar-z","items":"Br-z","featureCss":"Cr-z","disabled":"Dr-z","imgCss":"Er-z"};